import { useQuery } from "@tanstack/react-query";
import {
  auditLogService,
  AuditLogFilters,
} from "../services/admin/auditLog.service";

export function useMyActivity(filters: Omit<AuditLogFilters, "userId"> = {}) {
  return useQuery({
    queryKey: ["audit-logs", "me", filters],
    queryFn: () => auditLogService.getMyActivity(filters),
    placeholderData: (previousData: any) => previousData,
  });
}
